export default __webpack_public_path__ + "static/media/advanced1.5adda0c7.png";